import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../services/api';
import logoImg from '../../assets/img.jpg';
import './EcommerceNav.css';

const EcommerceNav = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [cartCount, setCartCount] = useState(0);
  const [wishlistCount, setWishlistCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    if (user) {
      fetchCartCount();
      fetchWishlistCount();
    }
    fetchCategories();
  }, [user]);

  const fetchCartCount = async () => {
    try {
      const response = await api.get('/api/ecommerce/cart');
      if (response.data.success) {
        setCartCount(response.data.data.totalItems || 0);
      }
    } catch (error) {
      console.error('Error fetching cart count:', error);
    }
  };

  const fetchWishlistCount = async () => {
    try {
      const response = await api.get('/api/ecommerce/wishlist');
      if (response.data.success) {
        setWishlistCount(response.data.data.length || 0);
      }
    } catch (error) {
      console.error('Error fetching wishlist count:', error);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await api.get('/api/ecommerce/categories');
      if (response.data.success) {
        setCategories(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      const q = encodeURIComponent(searchQuery.trim());
      // Reset to first page when performing a new search
      navigate(`/ecommerce?search=${q}&page=1`);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/ecommerce');
  };

  return (
    <nav className="ecommerce-nav">
      <div className="nav-container">
        {/* Logo */}
        <Link to="/ecommerce" className="nav-logo">
          <img src={logoImg} alt="AVS Store" className="nav-logo-img" />
        </Link>

        {/* Search Bar */}
        <form onSubmit={handleSearch} className="nav-search">
          <input
            type="text"
            placeholder="Search products..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-input"
          />
          <button type="submit" className="search-btn">
            <span>🔍</span>
          </button>
        </form>

        {/* Navigation Links */}
        <div className="nav-links">
          <Link to="/ecommerce" className="nav-link">
            Home
          </Link>
          
          <Link to="/ecommerce/categories" className="nav-link">
            Categories
          </Link>
          
          {/* Deals button removed as requested */}
        </div>

        {/* User Actions */}
        <div className="nav-actions">
          {user ? (
            <>
              {/* Wishlist */}
              <Link to="/ecommerce/wishlist" className="nav-action">
                <span className="action-icon">♡</span>
                <span className="action-text">Wishlist</span>
                {wishlistCount > 0 && (
                  <span className="action-badge">{wishlistCount}</span>
                )}
              </Link>

              {/* Cart */}
              <Link to="/ecommerce/cart" className="nav-action">
                <span className="action-icon">🛒</span>
                <span className="action-text">Cart</span>
                {cartCount > 0 && (
                  <span className="action-badge">{cartCount}</span>
                )}
              </Link>

              {/* User Menu */}
              <div className="user-menu">
                <span className="nav-action">
                  <span className="action-icon">👤</span>
                  <span className="action-text">{user.name}</span>
                </span>
                <div className="user-dropdown">
                  <Link to="/ecommerce/orders" className="dropdown-item">
                    My Orders
                  </Link>
                  <Link to="/ecommerce/billing" className="dropdown-item">
                    My Billing
                  </Link>
                  <Link to="/ecommerce/profile" className="dropdown-item">
                    Profile
                  </Link>
                  <Link to="/ecommerce/wishlist" className="dropdown-item">
                    Wishlist
                  </Link>
                  <button onClick={handleLogout} className="dropdown-item logout">
                    Logout
                  </button>
                </div>
              </div>
            </>
          ) : (
            <div className="auth-actions">
              <Link to="/login" className="nav-action">
                <span className="action-text">Login</span>
              </Link>
              <Link to="/register" className="nav-action">
                <span className="action-text">Register</span>
              </Link>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default EcommerceNav;
